import { useCallback, useMemo } from 'react'

interface UsePeriodLockedOptions {
    entriesLockedUntil: string | null
    periodStart: string
    periodEnd: string
}

export function usePeriodLocked({
    entriesLockedUntil,
    periodStart,
    periodEnd,
}: UsePeriodLockedOptions) {
    const isDateLocked = useCallback(
        (date: string) => {
            if (!entriesLockedUntil) return false
            return date < entriesLockedUntil
        },
        [entriesLockedUntil]
    )

    const isPeriodLocked = useMemo(() => {
        if (!entriesLockedUntil) return false
        return periodEnd <= entriesLockedUntil
    }, [entriesLockedUntil, periodEnd])

    const isPeriodPartiallyLocked = useMemo(() => {
        if (!entriesLockedUntil) return false
        return periodStart < entriesLockedUntil && periodEnd > entriesLockedUntil
    }, [entriesLockedUntil, periodStart, periodEnd])

    return {
        entriesLockedUntil,
        isDateLocked,
        isPeriodLocked,
        isPeriodPartiallyLocked,
    }
}
